import { CostProjectionDto, ParkerCostDto } from "./CostProjectionSection";
import { SubscriptionParker } from "./Data/ApiTypes";
import { toIsoLocalDate } from "./Data/Date";
import { ServerRequestsCostProjectionDto } from "./shared/api/axios-client";

export function mapCostProjection(
  dto: ServerRequestsCostProjectionDto,
  parkers: SubscriptionParker[],
): CostProjectionDto | null {
  if (!dto) return null;

  const groups = (dto.groups ?? []).map((g) => {
    const groupParkers =
      g.groupId != null
        ? parkers.filter((p) => p.subscriptionGroupId === g.groupId)
        : [];

    // Map parkerCosts from API (cast as any since API types may not be updated yet)
    const rawParkerCosts = (g as any).parkerCosts ?? [];
    const parkerCosts: ParkerCostDto[] = rawParkerCosts.map((pc: any) => ({
      subscriptionParkerId: pc.subscriptionParkerId ?? 0,
      parkerName: pc.parkerName ?? "",
      startDate: pc.startDate ?? null,
      basePrice: pc.basePrice ?? 0,
      adjustment: pc.adjustment ?? 0,
      finalPrice: pc.finalPrice ?? 0,
      wasProrated: pc.wasProrated ?? false,
    }));

    return {
      groupId: g.groupId!,
      groupName: g.groupName ?? "Unallocated",
      parkerCount: g.parkerCount ?? 0,
      subtotal: g.subtotal?.amount ?? 0,

      parkers: groupParkers.map((p) => ({
        name: p.parker.name,
        startDate: p.startDate
      })),

      parkerCosts,

      appliedTiers: [],

      prorationLabel:
        (g.parkerCount ?? 0) > 0
          ? "Prorated charges for mid-period additions"
          : undefined,

      lineItems:
        g.lineItems?.map((li) => ({
          description: li.description ?? "",
          quantity: li.quantity ?? undefined,
          unitPrice: li.unitPrice?.amount ?? undefined,
          total: li.total?.amount ?? 0,
        })) ?? [],
    };
  });

  const basePrice =
    dto.groups
      ?.flatMap((g) => g.lineItems ?? [])
      .find((li) => (li.unitPrice?.amount ?? 0) > 0)
      ?.unitPrice?.amount ?? 0;

  return {
    total: dto.total!,
    basePrice,
    hasPreviousPeriodActivity: dto.hasPreviousPeriodActivity!,
    periodStartDate: toIsoLocalDate(dto.periodStartDate),
    groups,
  };
}